import { useGleapContext } from '../context/gleap';

export function useGleap<T extends string>() {
  const { gleap } = useGleapContext();

  const track = (event: T, config: Record<string, any>) => {
    gleap?.trackEvent(event, config);
  };

  const identify = (userId?: string, userProperties?: Record<string, any>) => {
    gleap?.identifyUser(userId, userProperties);
  };

  const reset = () => {
    gleap?.resetUser();
  };

  const updateContact = (properties: Record<string, any>) => {
    gleap?.updateContact(properties);
  };

  const isUserIdentified = () => {
    return gleap?.isUserIdentified() || false;
  };

  return { track, identify, reset, updateContact, isUserIdentified };
}
